var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgCalendarFilter = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 24,
    width: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.545 2.258h-2.608v2.263c0 .458-.385.83-.863.83s-.864-.372-.864-.83V2.258H7.79v2.263c0 .458-.388.83-.864.83-.478 0-.863-.372-.863-.83V2.258H3.455C1.548 2.261.002 3.744 0 5.575v14.019c.002 1.83 1.548 3.313 3.455 3.315h17.09c1.907-.002 3.453-1.486 3.455-3.315V5.574c-.002-1.83-1.548-3.313-3.455-3.316zm1.728 17.336c0 .439-.182.86-.507 1.172-.324.31-.764.485-1.22.485H3.454c-.954 0-1.728-.742-1.728-1.657V9.668h20.546zM7.79 2.258H6.063V.828C6.063.37 6.45 0 6.926 0c.478 0 .864.37.864.83v1.43zm10.147 0h-1.726V.828c0-.457.385-.828.863-.828s.863.37.863.83v1.43z"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCalendarFilter, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/calendar-filter.17804cbd.svg";
export { ForwardRef as ReactComponent };